import React from "react";
import { Col, Row, Upload } from "antd";
import { Controller } from "react-hook-form";
import { UploadOutlined } from "@ant-design/icons";
import styles from "./SupportingDocuments.module.css";

const SupportingDocuments = ({ control }) => {
  return (
    <Row gutter={[32, 20]}>
      <Col span={12}>
        <label
          htmlFor="file"
          style={{
            display: "block",
            marginBottom: 8,
            color: "#171717",
            fontWeight: 400,
          }}
        >
          <span>Accreditation Certificate</span>
          <span  style={{ color: "#8C8C8C" }}>{" (Optional)"}</span>
        </label>
        <Controller
          name="accrediation_certificate"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Upload
              beforeUpload={(file) => {
                onChange(file);
                return false;
              }}
              showUploadList={false}
              accept=".jpg,.png"
              status={error ? "error" : ""}
              className={styles.common_input_styles}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  border: `1px solid ${error ? "red" : "#D0D5DD"} `,
                  paddingInline: 16,
                  borderRadius: 8,
                  cursor: "pointer",
                }}
              >
                <UploadOutlined style={{ color: "#8C8C8C", width: "auto", marginRight: 12 }} />
                <div style={{ color: "#8C8C8C", fontFamily: "Inter" }}>
                  {value?.name ?? "Select a file to Upload"}
                </div>
              </div>
            </Upload>
          )}
        />
      </Col>

      <Col span={12}>
        <label
          htmlFor="file"
          style={{
            display: "block",
            marginBottom: 8,
            color: "#171717",
            fontWeight: 400,
          }}
        >
          <span>Operating License</span>
          <span  style={{ color: "#8C8C8C" }}>{" (Optional)"}</span>
        </label>
        <Controller
          name="operating_license"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Upload
              beforeUpload={(file) => {
                onChange(file);
                return false;
              }}
              showUploadList={false}
              accept=".jpg,.png"
              status={error ? "error" : ""}
              className={styles.common_input_styles}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  border: `1px solid ${error ? "red" : "#D0D5DD"} `,
                  paddingInline: 16,
                  borderRadius: 8,
                  cursor: "pointer",
                }}
              >
                <UploadOutlined style={{ color: "#8C8C8C", width: "auto", marginRight: 12 }} />
                <div style={{ color: "#8C8C8C", fontFamily: "Inter" }}>
                  {value?.name ?? "Select a file to Upload"}
                </div>
              </div>
            </Upload>
          )}
        />
      </Col>

      <Col span={12}>
        <label
          htmlFor="file"
          style={{
            display: "block",
            marginBottom: 8,
            color: "#171717",
            fontWeight: 400,
          }}
        >
          <span>Additional Documents</span>
          <span  style={{ color: "#8C8C8C" }}>{" (Optional)"}</span>
        </label>
        <Controller
          name="additional_document"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Upload
              beforeUpload={(file) => {
                onChange(file);
                return false;
              }}
              showUploadList={false}
              accept=".jpg,.png"
              status={error ? "error" : ""}
              className={styles.common_input_styles}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  border: `1px solid ${error ? "red" : "#D0D5DD"} `,
                  paddingInline: 16,
                  borderRadius: 8,
                  cursor: "pointer",
                }}
              >
                <UploadOutlined style={{ color: "#8C8C8C", width: "auto", marginRight: 12 }} />
                <div style={{ color: "#8C8C8C", fontFamily: "Inter" }}>
                  {value?.name ?? "Select a file to Upload"}
                </div>
              </div>
            </Upload>
          )}
        />
      </Col>
    </Row>
  );
};

export default SupportingDocuments;
